<template>
    <div class="pb-2 pt-1 px-3" style="background-color: rgb(255, 255, 255);">
        <div class="" v-if="phones.length" v-for="(phone, index) in phones">
            <div class="layout row my-2 pl-3">
                <div>{{ phone.phoneType }}</div>
                <div class="mx-2">-</div>
                <div>{{ formatPhoneNumber(phone.phoneNum) }}</div>
            </div>
            <v-divider
                style="margin-left: 0px !important;"
                v-if="index + 1 < phones.length"
            ></v-divider>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { formatPhoneNumber } from "../../utils/helpers.js";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function,
    },
    data() {
        return {
            phones: [],
        };
    },
    async created() {
        await this.loadPhones();
    },
    computed: {},
    methods: {
        async loadPhones() {
            const phones = await this.$http.get(
                "api/broadcast/getAccountPhones?accountID=" +
                    this.row.familyID +
                    "&all=true"
            );

            this.phones = phones;
        },
        formatPhoneNumber(value) {
            return formatPhoneNumber(value);
        },
    },
};
</script>
<style></style>
